import React, {memo} from 'react';
import {Button} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import PrivacyPolicyButton, {PrivacyPolicyButtonProps} from './PrivacyPolicyButton';

const Generic = ({
  pending,
  privacyPolicyUrl,
  onClick,
}: {
  pending: boolean;
  onClick: (event: React.MouseEvent) => void;
} & PrivacyPolicyButtonProps) => {
  const {t} = useTranslation();

  return (
    <>
      <Button
        onClick={onClick}
        label={!pending ? t('*:str_LabelContinue') : t('*:str_TitlePleaseWait')}
        buttonStyle={'secondary'}
        disabled={pending}
      />
      <PrivacyPolicyButton privacyPolicyUrl={privacyPolicyUrl} />
    </>
  );
};

export default memo(Generic);
